import React from "react";
import GoogleMapBlock from "../../../../components/Map";
import styles from "./styles.module.css";

export default React.memo(({ style }) =>
  <div className={styles.container}>
    <GoogleMapBlock className={style.map} />
  </div>,
);
